<div class="dialog-card-wrapper">
  <div mat-dialog-content class="dialog-content-wrapper">
    <div *ngIf="data.icon" class="dialog-icon-wrapper">
      <i [ngClass]="data.icon"></i>
    </div>
    <h2 mat-dialog-title class="title">{{ data.title }}</h2>
    <div class="message">{{ data.message }}</div>
  </div>

  <div mat-dialog-actions>
    <button mat-button *ngFor="let button of data.buttons" (click)="onButtonClick(button.value)" [class]="button.class">
      {{ button.text }}
    </button>
  </div>
</div>